import React, { useState, useContext, useEffect,useRef } from 'react';
import { Helmet } from "react-helmet";
import { useHistory } from 'react-router-dom';
import { AppDataContext, VLink } from "../AppDataContext"
import useNetwork from '../../useNetwork';
import { Loader } from '../Loader';
import CurrencyFormat from 'react-currency-format';
import useInfiniteScroll from "../../useInfiniteScroll";
import { ConfirmDialog } from '../ConfirmDialog';
import { Pickup } from '../../../src/components/account/Pickup';

export function Invoice(props) {
	const history = useHistory();
	const context = useContext(AppDataContext);

	//const context = useContext(AppDataContext);
	const { loading, networkError, netRequest, netRenderError } = useNetwork(true);
	const [invoice, setInvoice] = useState(null);
	const [badge, setBadge] = useState(null);
	const [successMessage, setSuccessMessage] = useState(null);
	const [errorMessage, setErrorMessage] = useState(null);
	const [message, setMessage] = useState(null);
	const [selectedSlotTime, setSelectedSlotTime] = useState(null);
	const [showModalInitially, setShowModalInitially] = useState(false);
	const [showPrintInitially, setShowPrintInitially] = useState(false);
	
	const loadInvoice = async (openSchedulerDialog) => {
 		
		const getInvoice = async (openSchedulerDialog) => {
			let url = 'api/site/GetInvoice/' + props.match.params.invoiceId;
			if (props.match.params.authkey) {
				url += '/' + props.match.params.authkey;
			}

			const response = await netRequest(url);

			if (response.data != null) {
				const invoice = response.data;

				if (openSchedulerDialog && invoice.hasScheduler && invoice.aValidCCPaymentMade && invoice.pickupTimesAvailable) {
					setShowModalInitially(true);
				}
				
				setInvoice(invoice);

				setSelectedSlotTime(response.data.pickupTimeStr);

				setMessage(response.data.paymentStatus);
				switch (response.data.paymentStatus) {
					case "Unpaid":
						setBadge("pending"); break;
					case "NoPaymentMethod":
						setMessage("No Payment Method!");
						setBadge("pending"); break;
					case "Processing":
						setBadge("pending"); break;
					case "Paid":
						setBadge("paid"); break;
					case "RefundDue":
						setMessage("Refund Due");
						setBadge("pending"); break;
					case "UnderPaid":
						setMessage("Under Paid");
						setBadge("pending"); break;
					case "Declined":
						setBadge("pending"); break;
					default:
						setBadge("pending"); break;
				};

				if (props.print && !props.match.params.authkey)
					setShowPrintInitially(true);
			}
		};

		await getInvoice(openSchedulerDialog);
	}

	const clickMakePayment = async () => {
		setSuccessMessage(null);
		setErrorMessage(null);

		const url = 'api/site/makepayment/';

		const resp = await netRequest(url, { Param: invoice.secureId});

		if (resp.isError) {
			return "An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")";
		} else if (resp.data?.message) {
			setErrorMessage(resp.data.message);
		} else {
			var message = "Payment has been made.";
			if (invoice.hasScheduler) {
				message += " You may now schedule pickup by clicking on the button, below.";
			}
			setSuccessMessage(message);
			await loadInvoice();
			return null;
		}

	}


	const notifySlotSelected = async (slotTime) => {
		setSelectedSlotTime(slotTime);
		await loadInvoice();
	};

	const [randomNumberOpener, setRandomNumberOpener] = useState(null);

	const notifyPickupOpening = () => {
		setSuccessMessage(null);
		setErrorMessage(null);
		setRandomNumberOpener(Math.random());
		setShowModalInitially(false);
	};

	const openPrint = () => {
		window.open("/invoice/" + invoice.secureId, "_blank", "width=800,height=600", true);
	};

	useEffect(async () => {

		if (props.match.params.invoiceId) {
			await loadInvoice(props.match.params.schedule == 'schedule');
		}

	}, [props.match.params.invoiceId]);

	useEffect(() => {
		if (showPrintInitially)
			setTimeout(window.print, 1000);
	}, [showPrintInitially])

	//if (networkError) {
	//    //return netRenderError();
	//    if (networkError === "Unauthorized") {
	//        return <Redirect to="/login" />;
	//    }
	//    return <Redirect to="/error" status={networkError} />

	//}
	//if (loading)
	//    return <></>

	return (
		<>
			{invoice && !props.print &&
				<>
					<ConfirmDialog cancelText="No" okText="Yes"
                    okClicked={clickMakePayment}
                    id="paymentConfirmModal"
                    headerText="Confirm Payment?"
					>
						<p>Pay your invoice for &nbsp;
							<CurrencyFormat decimalScale={2} fixedDecimalScale={true} value={invoice.amountDue} displayType={'text'} thousandSeparator={true} prefix={'$'} />
							&nbsp; now with your {context.brand} ending in {context.last4}?</p>
						<p>Note: If you want to change your payment method, you must change your card in Payment Settings</p>
					</ConfirmDialog>

				 
					<Pickup randomNumberOpener={randomNumberOpener} modalId="pickupModal" invoiceId={props.match.params.invoiceId} notifySlotSelected={notifySlotSelected} modalStateOpen={showModalInitially} />

					{invoice.hasScheduler &&
						<ConfirmDialog okText="OK"
							id="pickupQRCode"
							headerText="Pickup Code"
							modalSize="modal-md"
						>
							<div class="p-3 text-center">
								<img src={"/api/site/pickupqrcode/" + props.match.params.invoiceId} width="300" />
							</div>
						</ConfirmDialog>
					}
				 
				</>
			}

			<Loader loading={loading} />
			<Helmet>
				<title>
					Invoice
				</title>
			</Helmet>
			<section class="background-color py-1">
				<div class="container">

					{!props.print &&
						<div class="row mt-3">
							<div class="col-12 mb-3">
								<div class="d-flex justify-content-start">
									<VLink to="/dashboard/invoices" class="lot-navigation lot-navigation__prev">Back to Invoices</VLink>
								</div>
							</div>
							{successMessage &&
								<div class="col-12 mb-3">
									<div class="alert alert-success">{successMessage}</div>
								</div>
							}
							{errorMessage &&
								<div class="col-12 mb-3">
									<div class="alert alert-danger">{errorMessage}</div>
								</div>
							}
						</div>
					}
					{invoice &&
						<>
							<div class="row mt-3">
								<div class="col-3 px-0">
									<div class="p-3 text-left">
									{props.print &&
										<><img src="images/bnd-logo@2x.png" height="60px" title="Bid Next Door" alt="Bid Next Door Logo" /><br /><br /></>
									}
									<span class="fw-bold">Date: </span>{invoice.invoiceDateStr}
									</div>
								</div>

								<div class="col-6 px-0">
									<div class="d-block p-3 text-center position-relative invoice-header">
										<h1 class="d-inline display-6 me-3">Invoice #{invoice.invoiceNumber}</h1>
										<br/>
										<label className={"d-inline auction-label " + badge}>{message}</label>
									</div>
								</div>
								<div class="col-3 px-0">
									{!props.print ?
										<div class="text-center">
											<button class="btn btn-icon-only btn-download d-inline mx-auto" data-bs-toggle="modal" data-bs-target="#pickupQRCode"><i class="bi bi-qr-code"></i></button>
											<a class="btn btn-icon-only btn-download d-inline mx-auto" href={"/api/site/GetInvoicePDF/" + props.match.params.invoiceId} target="_blank"><i class="bi bi-download"></i></a>
											<button class="btn btn-icon-only btn-print d-inline mx-auto" onClick={openPrint}><i class="bi bi-printer"></i></button>
										</div>
									:
										<div class="col-4">
											<div class="p-3 text-center">
												<img src={"/api/site/pickupqrcode/" + props.match.params.invoiceId} width="100" />
											</div>
										</div>
									}
								</div>
							</div>
							<div class="row">
								<div class="col-4 px-0 mt-0">
									<div class="px-3 text-left">
										<span class="fw-bold">{invoice.bidderUserName}</span><br />
										{invoice.bidderUserCompanyName != null && invoice.bidderUserCompanyName.trim() != "" &&
											<span>{invoice.bidderUserCompanyName}<br /></span>
										}
										{invoice.bidderTaxExempt &&
											<>
												<span class="fw-bold">{invoice.taxIdState} Resale #</span><span>{invoice.taxId}<br /></span>
											</>
										}
										<span>Paddle #{invoice.paddleNumber}</span><br />
										<span>{invoice.bidderUserAddress1}</span><br />
										{invoice.bidderUserAddress2 != null && invoice.bidderUserAddress2.trim() != "" &&
											<span>{invoice.bidderUserAddress2}<br /></span>
										}
										<span>{invoice.bidderUserCity + ", " + invoice.bidderUserState + " " + invoice.bidderUserZip}</span><br /><br />
										<span>{invoice.bidderUserPhone}</span><br />
										<span>{invoice.bidderUserEmail}</span>
									</div>
								</div>

								<div class="col-4 px-0 text-left mt-0 pb-3">
									{(selectedSlotTime || (invoice.hasScheduler == false && invoice.aValidCCPaymentMade)) &&
										<>
											<span class="fw-bold">Pickup Appointment</span><br />
											<span>{selectedSlotTime ? selectedSlotTime : invoice.pickupTimeStr}</span>
											{invoice.auctionAddress != null &&
												<div class="mt-3">
													<span class="fw-bold">Pickup Address</span><br/>
													<span>{invoice.auctionAddress.address1}</span><br/>
													{(invoice.auctionAddress.address2 != null && invoice.auctionAddress.address2.trim() != '') &&
														<span>{invoice.auctionAddress.address2}<br/></span>
													}
													<span>{invoice.auctionAddress.city}, {invoice.auctionAddress.state} {invoice.auctionAddress.zip}</span>
												</div>
											}
										</>
									}
								</div>
								<div class="col-4 px-0 text-left mt-0 pb-3">
									{!props.print &&
										<div class="mb-3">
											{invoice.amountDue > 0 &&
												<button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#paymentConfirmModal">
													Pay Now
												</button>
											}
											{invoice.hasScheduler && invoice.aValidCCPaymentMade && invoice.pickupTimesAvailable &&
												<button data-bs-toggle="modal" data-bs-target="#pickupModal" onClick={notifyPickupOpening} class="btn btn-primary btn-sm mx-3">
													{selectedSlotTime ? "Change Pickup Slot" : "Select Pickup Slot"}
												</button>							
											}
										</div>
									}

									{props.print && invoice.notes != null && invoice.notes.trim() != "" &&
										<div class="mb-3">
											<span class="fw-bold">Invoice Notes:</span><br/>
											<span>{invoice.notes}</span>
										</div>
									}
									<span class="fw-bold">Auction Manager</span><br/>
									<span>{invoice.auctionManagerFirstName + " " + invoice.auctionManagerLastName}</span><br/>
									<span>{invoice.auctionManagerPhone}</span><br />
									<span>{invoice.auctionManagerEmail}</span>
								</div>

								<div class="col-12 px-0 text-center mt-0 pb-3 position-relative invoice-header">
									<img src={"api/site/SellerLogo/" + invoice.companySecureId} class="logo--md" alt={invoice.companyName} title={invoice.companyName} />
									<h1 class="d-inline display-6 mx-3 me-3 text-uppercase" style={{marginLeft:"10px"} }>{invoice.auctionTitle}</h1>
								</div>
					 
								<div class="col-12 mb-3">
									<div class="table-responsive">
										<table class="table align-middle table-borderless">
											<thead>
												<tr>
													<th scope="col"></th>
													<th scope="col">Lot #</th>
													<th scope="col">Title</th>
													<th scope="col">Code</th>
													<th scope="col" class="text-end">Hammer</th>
												</tr>
											</thead>
											<tbody>
												{invoice.lots.map(lot => (
													<tr key={"il" + lot.secureId}>
														<td>
															{lot.imageSecureId &&
																<img src={"/api/site/inventoryimage/" + lot.imageSecureId + "/30"} title={lot.title} alt={lot.title} />
															}
														</td>
														<td>
															{lot.lotNumber}
														</td>
														<td>
															{props.print ?
																<span className="text-uppercase">{lot.title}</span>
																:
																<VLink to={"/auction/" + lot.auctionSessionSecureId + "/lot/" + lot.secureId}
																	title={lot.title} className="text-uppercase">
																	{lot.title}
																</VLink>
															}
														</td>
														<td>{lot.code}</td>
														<td class="text-end">
															<CurrencyFormat decimalScale={2} fixedDecimalScale={true} value={lot.soldPrice} displayType={'text'} thousandSeparator={true} prefix={'$'} />
														</td>
													</tr>

												))}
											</tbody>
										</table>
									</div>

								</div>
								<div class="col-12 px-3 py-2 background-color invoice-footer">
									<div class="d-flex align-items-center justify-content-end">
										<span class="w-100 md-w-80 text-center text-md-end label">
											Total Hammer Price {(!invoice.bidderTaxExempt && invoice.salesTax) && "(T)"}
										</span>
										<span class="w-100 md-w-20 text-center text-md-end number">
											<CurrencyFormat decimalScale={2} fixedDecimalScale={true} value={invoice.hammerPrice} displayType={'text'} thousandSeparator={true} prefix={'$'} />
										</span>
									</div>
								</div>
								{/* Total Price Ends */}
								{/* Total Price */}
								<div class="col-12 px-3 py-2 background-color invoice-footer">
									<div class="d-flex align-items-center justify-content-end">
										<span class="w-100 md-w-80 text-center text-md-end label">
											Buyer's Premium ({<CurrencyFormat decimalScale={0} value={100 * invoice.buyersPremium} displayType={'text'} suffix={'%'} />})
											{(invoice.buyersPremiumTaxable && !invoice.bidderTaxExempt && invoice.salesTax) && " (T)" }
										</span>
										<span class="w-100 md-w-20 text-center text-md-end number">
											<CurrencyFormat decimalScale={2} fixedDecimalScale={true} value={invoice.premium} displayType={'text'} thousandSeparator={true} prefix={'$'} />
										</span>
									</div>
								</div>
								{/* Total Price Ends */}

								{(invoice.adjustments != null && invoice.adjustments.length > 0) &&
								<>
									<div class="col-12 px-3 py-2 background-color__lighter invoice-footer">
										<h3 class="text-center display-6">Item Adjustments</h3>

										<table class="table align-middle table-borderless">
											<thead>
												<tr>
													<th scope="col"></th>
													<th scope="col">Lot #</th>
													<th scope="col">Title</th>
													<th scope="col">Code</th>
													<th scope="col">Reason</th>
													<th scope="col" class="text-end">Charge/<span class="negative">(Credit)</span></th>
												</tr>
											</thead>
											<tbody>
												{invoice.adjustments.map((adjustment, ix) => (
													<tr key={"adj" + ix}>
														<td>
															{adjustment.lot.imageSecureId &&
																<img src={"/api/site/inventoryimage/" + adjustment.lot.imageSecureId + "/30"} title={adjustment.lot.title} alt={adjustment.lot.title} />
															}
														</td>
														<td>
															{adjustment.lot.lotNumber}
														</td>
														<td>
															<VLink to={"/auction/" + adjustment.lot.auctionSessionSecureId + "/lot/" + adjustment.lot.secureId}
																title={adjustment.lot.title}>
																{adjustment.lot.title}
															</VLink>
														</td>
														<td>{adjustment.lot.code}</td>
														<td>
															{adjustment.notes}
															&nbsp;{(adjustment.taxable && !invoice.bidderTaxExempt && invoice.salesTax) && "(T)"}
														</td>
														<td className={"text-end"}>
															<AccountingCurrencyFormat value={adjustment.amount} />
														</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>
									<div class="col-12 px-3 py-2 background-color invoice-footer">
										<div class="d-flex align-items-center justify-content-end">
											<span class="w-100 md-w-80 text-center text-md-end label"><span data-chargers-item-title="" class="bold">Adjustments Total</span></span>
											&nbsp;
											<span className={"w-100 md-w-20 text-center text-md-end number"}>
												<AccountingCurrencyFormat value={invoice.adjustmentsTotal} />
											</span>
										</div>
									</div>
								</>
								}

								{/* Changes Details Ends */}
								{(invoice.charges != null && invoice.charges.length > 0) &&
								<>
									<div class="col-12 px-3 py-2 background-color__lighter invoice-footer">
										<h3 class="text-center display-6">Charges and Credits</h3>

										<table class="table align-middle table-borderless">
											<thead>
												<tr>
													<th scope="col">Reason</th>
													<th scope="col" class="text-end">Charge/<span class="negative">(Credit)</span></th>
												</tr>
											</thead>
											<tbody>
												{invoice.charges.map((charge, ix) => (
													<tr key={"chg" + ix}>
														<td>
															{charge.notes}
															&nbsp;{(charge.taxable && !invoice.bidderTaxExempt && invoice.salesTax) && "(T)"}
														</td>
														<td className={"text-end"}>
															<AccountingCurrencyFormat value={charge.amount} />
														</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>
									<div class="col-12 px-3 py-2 background-color invoice-footer">
										<div class="d-flex align-items-center justify-content-end">
											<span class="w-100 md-w-80 text-center text-md-end label"><span data-chargers-item-title="" class="bold">Charges Total</span></span>
											&nbsp;
											<span className={"w-100 md-w-20 text-center text-md-end number"}>
												<AccountingCurrencyFormat value={invoice.chargesTotal} />
											</span>
										</div>
									</div>
								</>
								}
								{/* Sale Tax */}
								{invoice.salesTax &&
									<div class="col-12 px-3 py-2 background-color invoice-footer">
										<div class="d-flex align-items-center justify-content-end">
											<span class="w-100 md-w-80 text-center text-md-end label">
												{invoice.bidderTaxExempt &&
													<span class="pe-5">
														{invoice.taxIdState} #{invoice.taxId}
													</span>
												}
												{invoice.state} Sales Tax ({<CurrencyFormat decimalScale={2} value={100 * invoice.salesTax} displayType={'text'} suffix={'%'} />})
											</span>
											<span class="w-100 md-w-20 text-center text-md-end number">
												{!invoice.bidderTaxExempt ?
													<CurrencyFormat decimalScale={2} fixedDecimalScale={true} value={invoice.invoiceTax} displayType={'text'} thousandSeparator={true} prefix={'$'} />
												:
												"N/A"
												}
											</span>
										</div>
									</div>
								}
								{/* Sale Tax Ends */}
								{/* Payments */}
								{invoice.paymentsTotal &&
									<div class="col-12 px-3 py-2 background-color invoice-footer">
										<div class="d-flex align-items-center justify-content-end">
											<span class="w-100 md-w-80 text-center text-md-end label">Payments</span>
											<span class="w-100 md-w-20 text-center text-md-end number">
												<CurrencyFormat decimalScale={2} fixedDecimalScale={true} value={invoice.paymentsTotal} displayType={'text'} thousandSeparator={true} prefix={'$'} />
											</span>
										</div>
									</div>
								}
								{/* Payments */}
								{/* Total Due */}
								<div class="col-12 px-3 py-2 background-color invoice-footer">
									<div class="d-flex align-items-center justify-content-end invoice-footer__total">
										<span class="w-100 md-w-80 text-center text-md-end label">Total Due</span>
										<span class="w-100 md-w-20 text-center text-md-end number">
											<CurrencyFormat decimalScale={2} fixedDecimalScale={true} value={invoice.amountDue} displayType={'text'} thousandSeparator={true} prefix={'$'} />
										</span>
									</div>
								</div>
						</div>
					</>
						}
					</div>
			</section>
		</>
	);

}

const AccountingCurrencyFormat = (props) => {
	return (
		<span className={props.value < 0 ? "negative" : "" }>
			{(props.value < 0) && "(" }
			<CurrencyFormat decimalScale={2} fixedDecimalScale={true} value={Math.abs(props.value)} displayType={'text'} thousandSeparator={true} prefix={'$'} />
			{(props.value < 0) && ")"}
		</span>
	)
}